import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useDuplicateStandardizationProject = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(async (id) => {
    const duplicatedProject = await axios.post(`/standardization/${id}/duplicate`);
    return duplicatedProject;
  });

  const duplicateProject = (projectId, { onSuccess }) => {
    mutate(projectId, {
      onSuccess: (res) => {
        queryClient.invalidateQueries('standardizationProjects', { exact: true });
        toast.success(`The project ${res.data.name} has been successfully duplicated`);
        onSuccess && onSuccess(res.data);
      },
      onError: (res) => {
        toast.error(res.message);
      },
    });
  };

  return {
    duplicateProject,
    isLoading,
  };
};

export default useDuplicateStandardizationProject;
